import { Component, OnInit } from '@angular/core';
import { PaymentsPaginatorInterface } from '../../models/payments.paginator.interface';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { select, Store } from '@ngrx/store';
import { PaymentsInterfaceState } from '../../store/state/payments.state';
import { GetPayments } from '../../store/actions/payments.actions';
import { CustomerMsisdnNotificationPaginatorInterface } from '../../../shared/models/customer-msisdn-notification-paginator.interface';
import { MsisdnNotificationsInterfaceState } from '../../../shared/store/state/msisdn-notifications.state';
import {
  DeleteCustomerNotifications,
  GetCustomerNotifications
} from '../../../shared/store/actions/customer-msisdn-notifications.actions';
import { UpdateSelectedProcedure } from '../../../shared/store/actions/selected-procedure.actions';
import { PaginatorInterface } from '../../../shared/models/paginator.interface';
import { UpdatePaginator } from '../../../shared/store/actions/paginator.actions';
import { PaymentsService } from '../../services/payments.service';
import { PaymentScheduleInterface } from '../../models/payment.schedule.interface';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { PaymentInterface } from '../../models/payment.interface';
import * as FileSaver from 'file-saver';
import { SupportUserInterface } from '../../../shared/models/support-user.interface';
import { ExtranetService } from '../../../shared/services/extranet.service';
import { environment } from '../../../../../environments/environment';
import { GetWallet } from '../../store/actions/wallet.actions';
import { WalletPaginatorInterface } from '../../models/wallet.paginator.interface';
import { WalletInterfaceState } from '../../store/state/wallet.state';

@Component({
  selector: 'app-payments-list',
  templateUrl: './payments-list.component.html',
  styleUrls: ['./payments-list.component.css'],
  standalone: false
})
export class PaymentsListComponent implements OnInit {

  payments: PaymentsPaginatorInterface;
  paymentsSchedule: Array<PaymentScheduleInterface>;
  currentSelectedPage: number;
  totalItemsPerPage: number = 5;
  notificationsPaginator: CustomerMsisdnNotificationPaginatorInterface;
  hideSchedule: boolean;
  paymentsListTab: string;
  paymentManagementTab: string;
  walletListTab: string;
  notificationsTab: string;
  faqPageCode: string;
  procedureInParam: string;
  supportUser: SupportUserInterface;
  environment = environment;
  brand?: string;
  wallet?: WalletPaginatorInterface;

  constructor(
      private paymentsService: PaymentsService,
      private store: Store<any>,
      private location: Location,
      private activateRoute: ActivatedRoute,
      private extranetService: ExtranetService
  ) {}

  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_PAYMENTS)).subscribe((response: PaymentsInterfaceState) => {
      if (response.payments) {
        this.payments = response.payments;
        this.store.dispatch(new UpdatePaginator(this.getPaginator(null)));
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_WALLET)).subscribe((response: WalletInterfaceState) => {
      if (response.wallet) {
        this.wallet = response.wallet;
        this.store.dispatch(new UpdatePaginator(this.getWalletPaginator(null)));
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_CUSTOMER_MSISDN_NOTIFICATIONS)).subscribe((response: MsisdnNotificationsInterfaceState) => {
      if (response.result != null) {
        this.notificationsPaginator = response.result;
      }
    });

    this.brand = environment.data.brand;
    if (this.activateRoute.snapshot.params['procedure'] === 'crediter-compte') {
      this.procedureInParam = this.activateRoute.snapshot.params['procedure'];
    }
    this.supportUser = this.extranetService.getSupportUser();
    this.paymentsSchedule = [];
    this.hideSchedule = true;
    this.payments = null;
    this.wallet = null;
    this.currentSelectedPage = 1;
    this.store.dispatch(new GetPayments(this.currentSelectedPage, this.totalItemsPerPage));
    this.store.dispatch(new GetCustomerNotifications('payment', 1, 5));
    this.setActiveTab(this.activateRoute.snapshot.params['tab'], true);
  }

  situationText(total: number) {
    if (total === 0) {
      return 'Vous n\'avez rien à régler';
    }
    if (total < 0) {
      return 'La somme de <strong>' + Math
        .abs(total)
        .toFixed(2)
        .toString()
        .replace('.', ',') + '€</strong> se déduira de vos prochaines factures';
    }
    if (total > 0) {
      return 'Vous nous devez <strong>' + total
        .toFixed(2)
        .toString()
        .replace('.', ',') + '€</strong>';
    }
    return '';
  }

  decimalComma(price: number): string {
     return Math.abs(parseFloat(price.toString())).toFixed(2).replace(/\./g, ',');
  }

  displaySchedule(e) {
    e.preventDefault();
    this.hideSchedule = !this.hideSchedule;
    if (this.paymentsSchedule.length === 0) {
      const explodeDate = this.payments.date.split('/');
      this.paymentsService.getSchedule(parseInt(explodeDate[2] + '' + explodeDate[1], 10), 12).subscribe(response => {
        this.paymentsSchedule = response;
      });
    }

    if (this.hideSchedule) {
      e.currentTarget.innerHTML = 'Afficher l\'échéancier<span></span>';
    } else {
      e.currentTarget.innerHTML = 'Masquer l\'échéancier<span></span>';
    }
  }

  setActiveTab(tab: string, withParams: boolean) {
    this.paymentManagementTab = '';
    this.paymentsListTab = '';
    this.walletListTab = '';
    this.notificationsTab = '';
    if (['', 'undefined', undefined].indexOf(tab) !== -1) {
      tab = 'liste';
      this.faqPageCode = 'paiements_liste';
    }

    switch (tab) {
      case 'liste':
        this.paymentsListTab = 'active';
        this.faqPageCode = 'paiements_liste';
        this.store.dispatch(new UpdatePaginator(this.getPaginator(null)));
        break;
      case 'gestion':
        this.paymentManagementTab = 'active';
        this.faqPageCode = 'paiements_gestion';
        break;
      case 'walletList':
        if (this.brand === 'lacarte') {
          this.walletListTab = 'active';
          this.store.dispatch(new GetWallet(this.currentSelectedPage, this.totalItemsPerPage));
        }
        this.faqPageCode = 'paiements_gestion';
        break;
      case 'notifications':
        this.notificationsTab = 'active';
        this.faqPageCode = 'paiements_notifications';
        this.store.dispatch(new UpdatePaginator(this.getPaginator('payment')));
        if (
            this.notificationsPaginator &&
            this.notificationsPaginator.totalUnread > 0 &&
            this.notificationsPaginator.data.length > 0 &&
            this.supportUser == null
        ) {
          this.store.dispatch(new DeleteCustomerNotifications(this.notificationsPaginator.data[0].id));
        }
        break;
    }
    this.store.dispatch(new UpdateSelectedProcedure(''));
    let url = '/paiements/' + tab;
    if (this.procedureInParam && withParams) {
      url += '/' + this.procedureInParam;
    }
    this.location.replaceState(url);
  }

  getCreditFile(payment: PaymentInterface) {
    this.paymentsService.downloadCreditFile(payment.id, payment.file.replace('/home/_services_/pxl_files/', '')).subscribe(
        (file: Blob) => {
          FileSaver.saveAs(new Blob([file], { type: 'application/pdf' }), payment.file.replace('/home/_services_/pxl_files/', ''));
        }
    );
  }

  getInvoiceCredit(payment: PaymentInterface) {
    this.paymentsService.downloadInvoiceCredit(payment.id, 'avoir').subscribe(
        (file: Blob) => {
          FileSaver.saveAs(new Blob([file], { type: 'application/pdf' }), 'avoir');
        }
    );
  }

  private getPaginator(type?: string) {
    return {
      currentSelectedPage: this.payments.currentPage,
      selectedLine: null,
      action: GetPayments,
      totalItems: this.payments.totalItems,
      type,
    } as PaginatorInterface;
  }

  private getWalletPaginator(type?: string) {
    return {
      currentSelectedPage: this.payments.currentPage,
      selectedLine: null,
      action: GetWallet,
      totalItems: this.payments.totalItems,
      type,
    } as PaginatorInterface;
  }
}
